<section class="container-fluid events my-5">
  <div class="allevents  " style="display: flex; flex-direction: column;">
    <h1 class="sec-head" data-aos="fade-down" style="text-align: center;">الفاعليات القادمة</h1>


    <ul data-aos="fade-right" data-aos-duration="3000" ngbNav #nav="ngbNav" [destroyOnHide]="false"
      class="mb-5 nav-tabs d-flex justify-content-center">
      <li ngbNavItem>
        <button class="navbutton" ngbNavLink >المعارض والمؤتمرات</button>
        <ng-template ngbNavContent>
          <ngx-slick-carousel data-aos="fade-up" data-aos-duration="3000" class="carousel"
            #slickModalLatest="slick-carousel" [config]="sliderConfig">
            <div ngxSlickItem style="position: relative " *ngFor="let event of exhibitionSliderData; let i = index;"
              class="slide events-slide ">
              <div class="icon-before" *ngIf="isCenterCard(i)">
                <img src="assets/images/icon-before.png" alt="Icon Before">
              </div>
              <app-home-events-item [exhibition]="event" ></app-home-events-item>
              <div class="icon-after" *ngIf="isCenterCard(i)">
                <img src="assets/images/icon-after.png" alt="Icon After">
              </div>
            </div>
          </ngx-slick-carousel>
        </ng-template>
      </li>
      <li ngbNavItem>
        <button class="navbutton" ngbNavLink >  الدورات وورش العمل</button>
        <ng-template ngbNavContent>
          <ngx-slick-carousel data-aos="fade-up" data-aos-duration="3000" class="carousel"
            #slickModalLatest="slick-carousel" [config]="sliderConfig">
            <div ngxSlickItem style="position: relative " *ngFor="let courseItem of coursesData; let i = index;"
              class="slide events-slide ">
              <div class="icon-before" *ngIf="isCenterCard(i)">
                <img src="assets/images/icon-before.png" alt="Icon Before">
              </div>
              <app-home-events-item [seminar]="courseItem" ></app-home-events-item>
              <div class="icon-after" *ngIf="isCenterCard(i)">
                <img src="assets/images/icon-after.png" alt="Icon After">
              </div>
            </div>
          </ngx-slick-carousel>
        </ng-template>
      </li>
      <li ngbNavItem>
        <button class="navbutton" ngbNavLink >الندوات والمحاضرات</button>
        <ng-template ngbNavContent>

          <ngx-slick-carousel data-aos="fade-up" data-aos-duration="3000" class="carousel"
          #slickModalLatest="slick-carousel" [config]="sliderConfig">
          <div ngxSlickItem style="position: relative " *ngFor="let seminarItem of seminarData; let i = index;"
            class="slide events-slide ">
            <div class="icon-before" *ngIf="isCenterCard(i)">
              <img src="assets/images/icon-before.png" alt="Icon Before">
            </div>
            <app-home-events-item [lecture]="seminarItem"></app-home-events-item>
            <div class="icon-after" *ngIf="isCenterCard(i)">
              <img src="assets/images/icon-after.png" alt="Icon After">
            </div>
          </div>
        </ngx-slick-carousel>

        </ng-template>
      </li>
    </ul>

    <div [ngbNavOutlet]="nav"></div>
    <!-- <ngx-slick-carousel data-aos="fade-up"
    data-aos-duration="3000"class="carousel" #slickModalLatest="slick-carousel" [config]="sliderConfig">
      <div ngxSlickItem style="position: relative " *ngFor="let event of selectedEvents; let i = index;"
        class="slide events-slide ">
        <div class="icon-before" *ngIf="isCenterCard(i)">
          <img src="assets/images/icon-before.png" alt="Icon Before">
        </div>
        <app-home-events-item [event]="event"></app-home-events-item>
        <div class="icon-after" *ngIf="isCenterCard(i)">
          <img src="assets/images/icon-after.png" alt="Icon After">
        </div>
      </div>
    </ngx-slick-carousel> -->

    <div class=" d-flex justify-content-center mt-3" role="group" dir="ltr">
      <a (click)="latestNext()"
        style="display: flex ;flex-direction: column; justify-content: center; cursor: pointer; background-color: rgb(6, 192, 192); width: 50px;height: 50px; padding-inline:30px;"
        class=" ">
        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0.25004 6.00028L5.55379 0.696533L7.32129 2.46528L3.78504 6.00028L7.32129 9.53528L5.55379 11.304L0.25004 6.00028Z"
            fill="white" />
        </svg>

      </a>
      <a (click)="latestPrev()"
        style="display: flex ;flex-direction: column; justify-content: center; cursor: pointer; background-color: rgb(6, 192, 192); width: 50px;height: 50px; padding-inline:30px;"
        class="">
        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.74996 5.99972L2.44621 11.3035L0.678711 9.53472L4.21496 5.99972L0.678711 2.46472L2.44621 0.695967L7.74996 5.99972Z"
            fill="white" />
        </svg>


      </a>
    </div>

  </div>
</section>
<section class="economynews">
  <div class="overlay"></div> <!-- Overlay added here -->
  <div class="">
    <div class="row">

      <div class="col-md-8 ">
        <h1 data-aos="fade-down" data-aos-duration="3000" class="mt-5"
          style="text-align: center; position: relative; color: white; ">اخر الاخبار الاقتصادية</h1>
        <ngx-slick-carousel *ngIf="paginatedEvents?.length>0" data-aos="fade-up" data-aos-duration="3000" #slickModal="slick-carousel"
          [config]="sliderConfig">

          <div ngxSlickItem class="slide" *ngFor="let eventparent  of paginatedEvents" >
            <div class="container items "  *ngFor="let event  of eventparent" >
              <div class="newsbar d-flex  justify-content-between   ">
                <div class=" p-3 "> {{event?.flatData?.newsTitle}}</div>
                <div class=" d-flex justify-content-between p-3 date-container">
                  <span> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white"
                      class="bi bi-calendar" viewBox="0 0 16 16">
                      <path
                        d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                    </svg></span>
                  <span> {{event?.flatData?.publishDate|date}}</span>
                </div>
              </div>
            </div>
          </div>
     

        </ngx-slick-carousel>
        >
      </div>

      <div data-aos="flip-left" data-aos-duration="3000" class="localeconomy col-md-3" style=" position: relative;">
        <div style="height: 100%;">
          <img src="assets/images/Rectangle 1273.png" class="img-fluid" style="min-height: 100%; width:100%;">

        </div>

        <div class="substract" style="max-width: 80%;max-height:80%;">
          <img src="assets/images/Subtract.png" class="img-fluid" style="min-width: 100% ;min-height: 100%;">

        </div>
        <div class="inner ">
          <h1>اقتصادنا خلال هذا الاسبوع</h1>
          <p [innerHTML]="homeData[0]?.flatData?.weeklyEconomicSummary">
          </p>
          <div class="d-grid vstack gap-3 mt-5">
            <button routerLink="archive" class="archive btn btn-light"> <svg width="18" height="12" viewBox="0 0 18 12"
                fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.99998 11.625C3.11159 11.625 0.192218 6.49163 0.0708591 6.27323C0.0243879 6.18964 0 6.09557 0 5.99993C0 5.90429 0.0243879 5.81022 0.0708591 5.72662C0.192218 5.50838 3.11159 0.375 8.99998 0.375C14.8884 0.375 17.8078 5.50837 17.9291 5.72677C17.9756 5.81036 18 5.90443 18 6.00007C18 6.09572 17.9756 6.18978 17.9291 6.27338C17.8078 6.49162 14.8884 11.625 8.99998 11.625ZM1.22441 5.99916C1.8935 7.0132 4.52052 10.5 8.99998 10.5C13.4937 10.5 16.109 7.01602 16.7756 6.00084C16.1065 4.9868 13.4795 1.5 8.99998 1.5C4.50631 1.5 1.89097 4.98398 1.22441 5.99916ZM8.99998 9.375C7.13895 9.375 5.62498 7.86103 5.62498 6C5.62498 4.13897 7.13895 2.625 8.99998 2.625C10.861 2.625 12.375 4.13897 12.375 6C12.375 7.86103 10.861 9.375 8.99998 9.375ZM8.99998 3.75C7.75939 3.75 6.74998 4.75941 6.74998 6C6.74998 7.24059 7.75939 8.25 8.99998 8.25C10.2406 8.25 11.25 7.24059 11.25 6C11.25 4.75941 10.2406 3.75 8.99998 3.75Z"
                  fill="#041364" />
              </svg>
              عرض الارشيف

            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>
<section class="stock-market container-fluid my-5 ">
  <div class="">
    <div data-aos="fade-up" data-aos-duration="6000" class="row">
      <div class="col-12 d-flex flex-column" style="align-items: center;">
        <h1 class="sec-head"> بورصة العملاء</h1>
        <p>آخر تحديث: {{currencyTimeLastUpdate |date}}</p>

        <div class="form my-5">
          <i class="fa fa-search"></i>
          <input type="text" class="form-control form-input" [(ngModel)]="searchText"
            placeholder="ابحث بواسطة العملة..." style="min-width: 500px;">
        </div>

      </div>
    </div>

    <div data-aos="fade-up" data-aos-once="true" data-aos-duration="3000" class="row">
      <app-currency-table [data]="currencyData"></app-currency-table>
    </div>
  </div>
</section>
<section class="fixed-actions">
  <ul class="list-unstyled actions-list">
    <!-- First item -->
    <li data-aos="fade-down" class="actions-list__item" ngbTooltip=" تحويل عملة " placement="end"
      tooltipClass="side-bar-tooltip">
      <a class="actions-btn" (click)="openModel()">
        <img src="assets/images/Frame (4).svg" class="shake-icon" />
      </a>
    </li>

    <!-- Second item (Feedback) -->
    <li data-aos="fade-right" data-aos-duration="6000W" class="actions-list__item" ngbTooltip="الدورات وورش العمل "
      placement="end" tooltipClass="side-bar-tooltip">
      <a routerLink="events/seminars" id="feedbackBtn" class="actions-btn">
        <img src="assets/images/icon-5.png" alt="icon" class="shake-icon" />
      </a>

    </li>

    <!-- Third item -->
    <li data-aos="fade-up" class="actions-list__item" ngbTooltip="الدراسات والابحاث" placement="end"
      tooltipClass="side-bar-tooltip">
      <a class="actions-btn" routerLink="versions/studies">
        <img src="assets/images/icon-4.png" alt="icon" class="shake-icon" />
      </a>
    </li>
  </ul>
</section>
<section>
  <!-- The Modal -->
  <div class="modal" id="myModal">
    <div class="modal-content">
      <!-- Modal body -->
      <div class="modal-body">
        <div class="converter-container">
          <h2>تحويل عملة</h2>
          <p>آخر تحديث: {{ currencyTimeLastUpdate | date }}</p>
  
          <form [formGroup]="convertCurrencyForm">
            <div class="currency-converter">
              <div class="currency-field">
                <input
                  formControlName="firstInput"
                  type="number"
                  placeholder="49"
                  class="form-control amount-input"
                  id="exampleInputEmail1"
                  (input)="updateConvertedAmount()"
                />
                <select
                  formControlName="first"
                  id="fromCurrency"
                  class="amount-input bg-danger form-select currency-select"
                  (change)="updateConvertedAmount()"
                >
                  <option *ngFor="let item of currencyData" [value]="item?.symbol">{{ item?.symbol }}</option>
                </select>
              </div>
  
              <div class="currency-field">
                <input
                  formControlName="secondInput"
                  type="text"
                  placeholder="1"
                  class="form-control amount-input"
                  [value]="convertedAmount | number : '1.2-2'"
                  readonly
                />
                <select
                  formControlName="second"
                  id="toCurrency"
                  class="amount-input form-select currency-select"
                  (change)="updateConvertedAmount()"
                >
                  <option *ngFor="let item of currencyData" [value]="item?.symbol">{{ item?.symbol }}</option>
                </select>
              </div>
            </div>
          </form>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="CloseModel()"></button>
      </div>
  
      <!-- Modal footer -->
      <div class="modal-footer">
        <button
          class="btn btn-primary btn-lg"
          (click)="reset()"
          style="background: #041364;"
        >
          إعادة ضبط
        </button>
        <button
          type="button"
          class="btn  btn-lg"
          data-bs-dismiss="modal"
          (click)="CloseModel()"
          style="color: #041364; border-color: #041364; width: 124px;"
        >
          الغاء
        </button>
      </div>
    </div>
  </div>
  
</section>